import { useState, useEffect, useCallback } from "react";
import { getFieldsByTags } from "../../services/api";
import { capitalize } from "@mui/material";
import { Option } from "../interface/interface";

export function useFieldOptions(areaTag: string) {
  const [fieldOptions, setFieldOptions] = useState<Option[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<null | Error>(null);

  const getFields = useCallback(async () => {
    if (!areaTag) return;
    setLoading(true);
    try {
      const response = await getFieldsByTags(areaTag);
      const data = response?.data || [];
      const options = data.map((field: string) => ({
        label: capitalize(field),
        value: field,
      }));
      setFieldOptions(options);
      setError(null);
    } catch (error) {
      setError(error as Error);
    } finally {
      setLoading(false);
    }
  }, [areaTag]);

  useEffect(() => {
    getFields();
  }, [getFields]);

  return { fieldOptions, loading, error };
}
